import { selector } from '@poa/state';

export const makeFilteredByStatus = (getGrouped, moduleName) =>
  selector(store => {
    const byStatus = {};
    getGrouped.get().forEach((table, idx) => {
      byStatus[idx] = table.tbody.slice();
    });
    return byStatus;
  });
